import moment from 'moment';
import has from 'lodash/has';


export function totalizar(nome: string, calendario: any[], rebanho: any[], produtos: any[]) {
  const coletado: any = {};

  // coletar dados
  calendario.forEach((mes) => {
    mes.categorias.forEach((categoria:any) => {
      categoria.produtos.forEach((produto:any) => {
        const oprod = produtos.find(i => i.id === produto.id);
        if (!oprod) throw new Error('Produto nao encontrado');

        let rproduto:any = {};
        if (!coletado.hasOwnProperty(produto.id)) {
          rproduto = {
            nome: oprod.nome,
            categorias: {},
            valor_frasco: oprod.valor_frasco,
            conteudo_frasco: oprod.conteudo_frasco,
          };
          coletado[produto.id] = rproduto;
        } else
          rproduto = coletado[produto.id];

        // aplicacoes
        if (rproduto.categorias.hasOwnProperty(categoria.id))
          rproduto.categorias[categoria.id].aplicacoes += 1;
        else
          rproduto.categorias[categoria.id] = {aplicacoes: 1};

        // dose media
        const ocat = rebanho.find(i => i.id === categoria.id);
        if (!ocat) throw new Error('Rebanho nao encontrado');

        const formula = oprod.formula_dose_media;
        const doseMedia = formula.replace(/\${peso_medio}/g, ocat.peso_medio);

        rproduto.categorias[categoria.id].dose_media = eval(doseMedia); // eslint-disable-line
        rproduto.categorias[categoria.id].num_animais = ocat.num_animais;
      });
    });
  });

  // totalizar
  const totalizado: any = {
    nome,
    data: moment(),
    total_geral: 0,
    total_animais: 0,
    produtos: {},
    categorias: {},
    observacoes: [],
  };

  Object.keys(coletado).forEach((pid) => {
    const produto = coletado[pid];
    let totalMl = 0;
    Object.keys(produto.categorias).forEach((catid) => {
      const categoria = produto.categorias[catid];
      let rcat;
      if (!has(totalizado.categorias, catid)) {
        const ocat = rebanho.find(i => i.id === Number.parseInt(catid, 10));
        rcat = {
          nome: ocat.nome,
          num_animais: ocat.num_animais,
          peso_medio: ocat.peso_medio,
          total: 0,
          observacoes: ocat.observacoes,
        };
        totalizado.categorias[catid] = rcat;
        totalizado.total_animais += ocat.num_animais;
      } else
        rcat = totalizado.categorias[catid];

      const mls = categoria.dose_media * categoria.aplicacoes * categoria.num_animais;
      totalMl += mls;

      rcat.total += mls * (produto.valor_frasco / produto.conteudo_frasco);
      // const frascos = mls / produto.conteudo_frasco;
      // rcat.total += frascos * produto.valor_frasco;
    });

    const totalFrascos = totalMl / produto.conteudo_frasco;
    const total = totalFrascos * produto.valor_frasco;

    totalizado.produtos[pid] = {
      ...produto,
      total_ml: totalMl,
      total_frascos: Math.ceil(totalFrascos),
      total,
    };

    totalizado.total_geral += total;
  });

  // observacoes
  rebanho.forEach((i) => {
    if (i.num_animais && has(i, 'observacoes') && i.observacoes) {
      totalizado.observacoes.push({
        nome: i.nome,
        texto: i.observacoes,
      });
    }
  });

  return totalizado;
}
